import Button from 'observian-ui/lib/button'

import style from './joinTeam.module.css'

const JoinTeam = () => (
  <div className={style.joinTeam}>
    <div className={style.content}>
      <svg
        className={style.mission}
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        width="1196"
        height="636"
        viewBox="0 0 1196 636"
      >
        <defs>
          <filter
            id="our-mission-a"
            width="118.5%"
            height="140.7%"
            x="-9.2%"
            y="-16.3%"
            filterUnits="objectBoundingBox"
          >
            <feOffset dy="20" in="SourceAlpha" result="shadowOffsetOuter1" />
            <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="30" />
            <feColorMatrix
              in="shadowBlurOuter1"
              values="0 0 0 0 0.11372549   0 0 0 0 0.192156863   0 0 0 0 0.274509804  0 0 0 0.165675951 0"
            />
          </filter>
          <linearGradient id="our-mission-c" x1="15.436%" x2="114.319%" y1="90.518%" y2="21.413%">
            <stop offset="0%" stopColor="#172A3F" />
            <stop offset="100%" stopColor="#344960" />
          </linearGradient>
          <filter
            id="our-mission-d"
            width="110.4%"
            height="169.6%"
            x="-5.2%"
            y="-34.8%"
            filterUnits="objectBoundingBox"
          >
            <feGaussianBlur in="SourceGraphic" stdDeviation="10" />
          </filter>
          <filter
            id="our-mission-e"
            width="107.3%"
            height="171%"
            x="-3.6%"
            y="-35.5%"
            filterUnits="objectBoundingBox"
          >
            <feGaussianBlur in="SourceGraphic" stdDeviation="10" />
          </filter>
          <linearGradient id="our-mission-f" x1="-5.302%" x2="52.302%" y1="178.507%" y2="-48.719%">
            <stop offset="0%" stopColor="#1D8DBA" />
            <stop offset="100%" stopColor="#03ECAE" />
          </linearGradient>
        </defs>
        <g fill="none" fillRule="evenodd" transform="translate(57 14)">
          <path
            d="M36.1532598,45.5821749 L1045.84526,45.5821749 C1049.36492,45.5821749 1052.33724,48.1955882 1052.7877,51.6862967 L1082,278.061378 L1052.71868,530.389074 C1052.30902,533.919209 1049.31916,536.582175 1045.76534,536.582175 L36.235868,536.582175 C32.681529,536.582175 29.6914089,533.918461 29.2823747,530.387737 L0,277.626509 L29.2110382,51.6846453 C29.6622415,48.1946727 32.6342411,45.5821749 36.1532598,45.5821749 Z"
            fill="#000"
            filter="url(#our-mission-a)"
          />
          <path
            d="M36.1532598,45.5821749 L1045.84526,45.5821749 C1049.36492,45.5821749 1052.33724,48.1955882 1052.7877,51.6862967 L1082,278.061378 L1052.71868,530.389074 C1052.30902,533.919209 1049.31916,536.582175 1045.76534,536.582175 L36.235868,536.582175 C32.681529,536.582175 29.6914089,533.918461 29.2823747,530.387737 L0,277.626509 L29.2110382,51.6846453 C29.6622415,48.1946727 32.6342411,45.5821749 36.1532598,45.5821749 Z"
            fill="#FFF"
          />
          <text
            fill="#1D354F"
            fillOpacity="0.9"
            fontFamily="GeomanistUltra, Geomanist"
            fontSize="31.5"
            letterSpacing="1.2"
          >
            <tspan x="98" y="198.809">
              What we&apos;ve set out to do
            </tspan>
          </text>
          <text fill="#1D354F" fillOpacity="0.9" fontFamily="Geomanist" fontSize="18">
            <tspan x="97" y="253.572" />
            <tspan x="97" y="307.572">
              Our mission is to improve the lives of technology professionals, and, ultimately, the
              bottom line of companies{' '}
            </tspan>
            <tspan x="97" y="334.572">
              they work for. Using the Cloud can revolutionize the way business is done, but
              it&apos;s not as simple as it can appear.{' '}
            </tspan>
            <tspan x="97" y="361.572">
              There are hidden pitfalls and common mistakes any organization can make. We&apos;ve
              mastered the challenges of{' '}
            </tspan>
            <tspan x="97" y="388.572">
              cloud solutions in an effort to help professionals
            </tspan>
            <tspan x="538.258" y="388.572" fontFamily="GeomanistBold, Geomanist">
              {' '}
              Do Cloud Better.
            </tspan>
          </text>
          <path
            fill="url(#our-mission-c)"
            fillOpacity="0.02"
            fillRule="nonzero"
            d="M881.969512,253.775479 L881.969512,330.599729 C881.979418,337.320297 878.397988,343.534078 872.577795,346.894359 L794.156953,392.209396 C788.345338,395.564733 781.185133,395.564733 775.373518,392.209396 L696.952677,346.894359 C691.132483,343.534078 687.551053,337.320297 687.560959,330.599729 L687.560959,253.775479 C687.539411,251.85227 688.551227,250.065317 690.211501,249.094396 C691.871775,248.123475 693.925295,248.117835 695.590878,249.079621 L777.674489,296.507794 C779.830938,297.759778 782.272039,298.43876 784.765236,298.480055 C787.273441,298.485144 789.737525,297.82049 791.902941,296.554753 L873.986552,249.126579 C875.641855,248.193043 877.668004,248.207064 879.310229,249.163419 C880.952454,250.119773 881.964556,251.875087 881.969512,253.775479 Z M710.946336,215.551189 L775.373518,178.406946 C781.185133,175.051609 788.345338,175.051609 794.156953,178.406946 L858.490218,215.551189 C860.206175,216.49043 861.273185,218.290858 861.273185,220.247048 C861.273185,222.203238 860.206175,224.003665 858.490218,224.942907 L789.461095,264.763789 C786.647751,266.410752 783.164472,266.410752 780.351129,264.763789 L710.946336,224.802031 C709.300386,223.843015 708.288067,222.081567 708.288067,220.17661 C708.288067,218.271653 709.300386,216.510205 710.946336,215.551189 Z M790.775935,86.18028 L932.215201,167.794305 C950.66536,178.446479 962.018515,198.144382 961.986946,219.448752 L961.986946,355.628656 C962.018515,376.933026 950.66536,396.630929 932.215201,407.283102 L814.490022,474.809551 C796.052673,485.45436 773.336923,485.45436 754.899574,474.809551 L637.221353,406.860475 C618.771194,396.208302 607.418039,376.510398 607.449609,355.206029 L607.449609,192.682357 C607.453976,188.296718 605.105801,184.245667 601.298034,182.069716 C597.497949,179.875702 592.816972,179.871668 589.013112,182.05913 C585.209251,184.246591 582.858345,188.294406 582.843309,192.682357 L582.843309,355.299946 C582.890321,385.401332 599.003584,413.187758 625.106038,428.179674 L742.502507,496.12875 C768.541135,511.150983 800.613668,511.150983 826.652296,496.12875 L944.424434,428.179674 C970.533979,413.19488 986.649854,385.403949 986.687163,355.299946 L986.687163,219.354835 C986.572624,189.271709 970.4775,161.516561 944.424434,146.475107 L803.173002,64.8610813 C799.368598,62.6868692 794.694926,62.7001831 790.902971,64.8960347 C787.111016,67.0918863 784.773144,71.1388287 784.765236,75.5206807 C784.753829,79.9082063 787.07984,83.9697783 790.869852,86.18028 L790.775935,86.18028 Z M671.219371,365.583877 C663.745998,361.257943 659.14622,353.275449 659.151014,344.640346 L659.151014,227.572587 C659.133853,218.946463 663.739201,210.972222 671.219371,206.676016 L772.790796,147.742988 C780.256117,143.42167 789.462189,143.42167 796.92751,147.742988 L898.498935,206.488182 C906.023277,210.832036 910.632447,218.884634 910.567292,227.572587 L910.567292,350.322336 C910.575238,354.71694 912.917853,358.776281 916.718867,360.981935 C920.520516,363.078778 925.143971,363.02543 928.896225,360.841426 C932.648479,358.657421 934.978359,354.663571 935.032716,350.322336 L935.032716,227.572587 C935.040909,210.143103 925.750743,194.032988 910.661209,185.309859 L809.23066,126.564665 C794.144346,117.87689 775.57396,117.87689 760.487646,126.564665 L658.916221,185.309859 C643.808613,194.021052 634.499247,210.133416 634.497755,227.572587 L634.497755,344.969057 C634.479865,362.401133 643.772628,378.515752 658.869262,387.231785 L766.404428,448.93537 C770.205804,451.085801 774.862298,451.059749 778.639375,448.866919 C782.416452,446.674089 784.747891,442.643208 784.765236,438.27577 C784.766936,433.878578 782.421741,429.814767 778.613661,427.616171 L671.219371,365.583877 Z"
          />
          <polygon
            fill="url(#our-mission-c)"
            points="82.613 536.125 285.477 583.801 658.895 497.547 325.793 561.625 135.691 535.965"
          />
          <polygon
            fill="url(#our-mission-c)"
            points="52.613 535.125 255.477 597.801 628.895 511.547 295.793 575.625 105.691 538.965"
            filter="url(#our-mission-d)"
            opacity="0.473"
          />
          <polygon
            fill="url(#our-mission-c)"
            points="995.996 45.109 451.773 0 170.547 84.453 459.309 16.922 702.193 45.109"
          />
          <polygon
            fill="url(#our-mission-c)"
            points="995.996 45.109 451.773 10 170.547 94.453 459.309 26.922 702.193 45.109"
            filter="url(#our-mission-e)"
          />
          <polygon
            fill="url(#our-mission-f)"
            points="98 226.203 171.547 228.516 266.91 232.359 171.953 231.548 103.153 233.858"
          />
        </g>
      </svg>
      <div className={style.mobile}>
        <h2>What we&apos;ve set out to do</h2>
        <p>
          Our mission is to improve the lives of technology professionals, and, ultimately, the
          bottom line of companies they work for. Using the Cloud can revolutionize the way business
          is done, but it&apos;s not as simple as it can appear. There are hidden pitfalls and
          common mistakes any organization can make. We&apos;ve mastered the challenges of
          cloud-based solutions in an effort to help professionals <strong>Do Cloud Better.</strong>
        </p>
      </div>
    </div>
    <div className={style.apply}>
      <h3>Are you passionate about cloud solutions and software improvement?</h3>
      <Button
        variant="primary"
        className={style.linkCTA}
        label="Join Our Team"
        href="https://www.linkedin.com/jobs/search/?f_C=11369737&locationId=OTHERS.worldwide"
      />
    </div>
  </div>
)

JoinTeam.defaultProps = {}

JoinTeam.propTypes = {}

export default JoinTeam
